<template>
  <div class="login-container">
    <div class="main-content-box flex align_items_ctr">
      <div class="logo pointer" v-if="true||isLoginCom" @click="handleIndex"></div>
      <div class="login-box" v-if="!showWxData">
        <component
          :is="currentCom"
          :isOverseaIp="isOverseaIp"
          @changeCom="changeCom"
          @wxBindAccount="wxBindAccount"
          @loginSuccess="loginSuccess"
          @findSuccess="findSuccess"
        />
      </div>
      <div class="login_box wx_bind" v-if="showWxData">
        <wxBind :wxData="wxData" @loginSuccess="loginSuccess" />
      </div>
    </div>
  </div>
</template>
<script>
import autoLogin from '@/utils/autoLogin.js'
import ValiCodeCom from './components/ValiCodeCom.vue'
import PhoneCom from './components/PhoneCom.vue'
import QrCom from './components/QrCom.vue'
import RegisterCom from './components/RegisterCom.vue'
import ChangePwd from './components/ChangePwd.vue'
import FindPwdByEmail from './components/FindPwdByEmail.vue'
import FindPwdByPhone from './components/FindPwdByPhone.vue'
import WxBind from './components/WxBind.vue'
import { getIp } from '@/apis/index.js'
export default {
  name: 'LoginPage',
  components: {
    ValiCodeCom,
    PhoneCom,
    QrCom,
    RegisterCom,
    ChangePwd,
    FindPwdByEmail,
    FindPwdByPhone,
    WxBind,
  },
  data() {
    return {
      isLoginCom: true,
      currentCom: 'ValiCodeCom',
      showWxData: false,
      isOverseaIp: false,
    }
  },
  mounted() {
    this.getIpAdd()
  },
  methods: {
    async getIpAdd() {
      try {
        let res = await getIp()
        this.isOverseaIp = /[^\x00-\xff]/.test(res.data)
      } catch (e) {
        console.log('e :>> ', e)
      }
    },
    changeCom(name, loginCom) {
      this.currentCom = name
      this.isLoginCom = loginCom
    },
    wxBindAccount(wxData) {
      this.wxData = wxData
      this.showWxData = true
    },
    //找回密码成功。手动登录
    findSuccess(res) {
      if ((res.data || res.msg) && this.$message.success(res.data || res.msg)) {
        this.currentCom = 'ValiCodeCom'
      }
    },
    async loginSuccess(res) {
      console.log('登录成功')
      sessionStorage.setItem('token', res.data)
      this.$message({
        type: 'success',
        message: res.msg,
      })
      // 先获取用户信息--再跳转--不然权限信息不能及时更新
      let path = this.$route.query.redirect ? decodeURIComponent(this.$route.query.redirect) : '/'
      autoLogin.goGetUserInfo()
      this.$router.push(path)
    },
    //点击图片跳转到首页
    handleIndex() {
      this.$router.push({
        path: '/',
      })
    },
  },
}
</script>
<style lang="less" scoped>
.login-container {
  min-width: 1360px;
  height: 100vh;
  background-image: url(../../assets/login/bg.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo {
  margin-right: 320px;
  width: 469px;
  height: 100px;
  background-image: url(../../assets/login/logo.png);
  background-size: contain;
}
.login-box {
  width: 460px;
}
</style>
